import React from "react";
import { motion } from "framer-motion";
import { FiSearch, FiRefreshCw } from "react-icons/fi";
import "./WSPEmptyState.css";

/**
 * WSPEmptyState - Empty Results State
 */
const WSPEmptyState = ({ hasFilters, onClearFilters }) => {
  return (
    <motion.div
      className="wsp-empty-state"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="wsp-empty-illustration">
        <div className="wsp-empty-circle">
          <FiSearch size={48} />
        </div>
        <div className="wsp-empty-dots">
          <span />
          <span />
          <span />
        </div>
      </div>

      <h3 className="wsp-empty-title">
        {hasFilters
          ? "No workshops match your filters"
          : "No workshops available"}
      </h3>

      <p className="wsp-empty-description">
        {hasFilters
          ? "Try adjusting your search criteria or clearing filters to see more results."
          : "Check back soon! New workshops are added regularly."}
      </p>

      {hasFilters && onClearFilters && (
        <button className="wsp-empty-action" onClick={onClearFilters}>
          <FiRefreshCw size={16} />
          Clear All Filters
        </button>
      )}
    </motion.div>
  );
};

export default WSPEmptyState;
